import React, { useState, FC, useEffect, memo, useRef, Dispatch, SetStateAction } from "react"
import Chart from "react-apexcharts"
import { ToggleViewState } from "pages/forecast/forecastTypes"

import { getRandomColor } from "utils/GenerateColors";

import { GraphSalesData, HighLightsData, salesFilterData } from "pages/sales-forecast/salesForecastTypes";
import { tooltipFormat } from "utils/formatDate";

import { getFileName } from 'utils/helper'
import jsPDF from 'jspdf'
import html2canvas from 'html2canvas';
import headerImage from "../../../assets/images/ronlogo.png"
import footerImage from "../../../assets/images/power-rysun-logo.png"

import autoTable from 'jspdf-autotable';
interface GraphProps {
  graphData: GraphSalesData | undefined
  downloadCsv: boolean
  setDownloadCsv: Dispatch<SetStateAction<boolean>>;
  currentUIView: ToggleViewState
  salesFilterData: salesFilterData
  cardRef: React.MutableRefObject<any>
  mapRef: React.MutableRefObject<any>

}


interface graphCountryType {
  country: string
  total_sales_forecast: number
  total_sales_history: number,
  forecasts: {
    date: string
    quantity: number
  }[]
  history: {
    date: string
    quantity: number
  }[]
}

interface graphStateType {

  state_name: string
  total_sales_forecast: number
  total_sales_history: number,
  forecasts: {
    date: string
    quantity: number
  }[]
  history: {
    date: string
    quantity: number
  }[]

}
// interface graphCityType {
//   country: string
//   state: string
//   total_sales_forecast: number
//   total_sales_history: number
//   city_data: {
//     city_name: string
//     total_sales_forecast: number
//     total_sales_history: number,
//     forecasts: {
//       date: string
//       quantity: number
//     }[]
//     history: {
//       date: string
//       quantity: number
//     }[]
//   }

// }

interface graphManagerType {
  city: string
  sales_manager: string
  total_sales_forecast: number
  total_sales_history: number,
  forecasts: {
    date: string
    quantity: number
  }[]
  history: {
    date: string
    quantity: number
  }[]

}
interface graphSalesRepType {
  city: string
  sales_manager: string
  sales_associate: string
  total_sales_forecast: number
  total_sales_history: number,
  forecasts: {
    date: string
    quantity: number
  }[]
  history: {
    date: string
    quantity: number
  }[]

}

interface SeriesSyntax {

  name: string,
  color: string,
  data: number[] | undefined

}

interface TableRow {
  col1: string | undefined
  col2: string | undefined
  col3: string | undefined
}

// Define the type for columns
interface TableColumn {
  title: string;
  dataKey: keyof TableRow; // Restrict dataKey to valid keys of TableRow
}
const Graph: FC<GraphProps> = memo(({ graphData, setDownloadCsv, downloadCsv, currentUIView,
  salesFilterData, cardRef, mapRef }) => {

  const [salesForecastSeries, setSalesForecastSeries] = useState<SeriesSyntax[]>([])
  const [salesHistorySeries, setSalesHistorySeries] = useState<SeriesSyntax[]>([])
  const [filterMode, setFilterMode] = useState("")

  const [LegendNames, setLegendNames] = useState<string[]>([])
  const chartRef = useRef<any>(null);

  const [date, setDate] = useState({
    pastDate: "",
    futureDate: "",
    lengthOfInventory: null
  })


  useEffect(() => {
    if (graphData) {
      const { country, state, city_name, sales_manager, sales_rep } = salesFilterData;

      const hasCountry = country.length > 0;
      const hasState = state.length > 0;
      const hasCity = city_name.length > 0;
      const hasManager = sales_manager.length > 0;
      const hasRep = sales_rep.length > 0;

      if (!hasCountry && !hasState && !hasCity && !hasManager && !hasRep) {
        makeCountryPlot();
        setFilterMode("country")
      } else if (hasCountry && !hasState && !hasCity && !hasManager && !hasRep) {
        makeStatePlot();
        setFilterMode("state")
      } else if ((hasCountry && hasState && !hasCity && !hasManager && !hasRep) ||
        (!hasCountry && hasState && !hasCity && !hasManager && !hasRep)) {
        makeCityPlot();
        setFilterMode("city")
      } else if ((hasCountry && hasState && hasCity && !hasManager && !hasRep) ||
        (!hasCountry && !hasState && hasCity && !hasManager && !hasRep) ||
        (!hasCountry && hasState && hasCity && !hasManager && !hasRep) ||
        (hasCountry && !hasState && hasCity && !hasManager && !hasRep)) {
        makeManagerPlot();
        setFilterMode("manager")
      } else if ((hasCountry && hasState && hasCity && hasManager && !hasRep) ||
        (!hasCountry && !hasState && !hasCity && hasManager && !hasRep) ||
        (hasCountry && !hasState && !hasCity && hasManager && !hasRep) ||
        (!hasCountry && hasState && !hasCity && hasManager && !hasRep) ||
        (!hasCountry && !hasState && hasCity && hasManager && !hasRep) ||
        (hasCountry && hasState && !hasCity && hasManager && !hasRep) ||
        (!hasCountry && hasState && hasCity && hasManager && !hasRep) ||
        (hasCountry && !hasState && hasCity && hasManager && !hasRep)) {
        makeSalesRepPlot();
        setFilterMode("rep")
      } else if (hasRep) {
        makeSalesRepPlot();
        setFilterMode("other")
      }
    }
  }, [graphData?.result]);


  // plot code
  const makeCountryPlot = async () => {

    let salesForecastArray: any = []
    let SalesHistoryArray: any = []

    let countryNames: string[] = []
    let colorIndex = 0


    graphData?.result.forEach((obj: graphCountryType) => {


      const { forecasts, history, country } = obj

      const localInventoryData = forecasts.length > 0 ? forecasts.map((item: any) => ({ x: item?.date, y: item?.quantity })) : []
      const localSalesData = history.length > 0 ? history.map((item: any) => ({ x: item?.date, y: item?.quantity })) : []
      // const localSafetyStock = safety_stock.map((item: any) => ({ x: item.date, y: item.quantity }))
      const { randomDarkColor, randomLightColor } = getRandomColor(colorIndex)


      salesForecastArray.push({ name: `${country}(SF)`, color: randomDarkColor, data: localInventoryData, })
      SalesHistoryArray.push({ name: `${country}(SH)`, color: randomLightColor, data: localSalesData, })

      //  SafetyStock.push({ name: `${category} (SS)`, color: randomDarkColor, data: localSafetyStock, strokeDashArray: 10.5  })

      // obj.product_id ? productNames.push(`${category} - ${product_name} (${product_id})`) : productNames = []
      countryNames.push(country)

      // localCategoriesName.push(category)

      if (colorIndex < 4) {
        colorIndex = colorIndex + 1

      }
      else {
        colorIndex = 0
      }
    })

    const maxLengthObjectSales = SalesHistoryArray.reduce((max: any, current: any) => current?.data?.length > max?.data?.length ? current : max, SalesHistoryArray[0]);

    const maxLengthObjectSalesForecast = salesForecastArray.reduce((max: any, current: any) => current?.data?.length > max?.data?.length ? current : max, salesForecastArray[0])

    setDate(prev => ({
      ...prev, futureDate: maxLengthObjectSalesForecast?.data?.[maxLengthObjectSalesForecast?.data?.length - 1]?.x,
      lengthOfInventory: maxLengthObjectSalesForecast?.data?.length, pastDate: maxLengthObjectSales?.data?.[0]?.x
    }))

    setLegendNames(countryNames)
    setSalesForecastSeries(salesForecastArray)
    setSalesHistorySeries(SalesHistoryArray)
    // setSafetyStockData(SafetyStock)



  }

  const makeStatePlot = async () => {

    let salesForecastArray: any = []
    let SalesHistoryArray: any = []

    let stateNames: string[] = []
    let colorIndex = 0


    graphData?.result[0].state_data.forEach((obj: graphStateType) => {


      const { forecasts, history, state_name } = obj

      const localInventoryData = forecasts?.length > 0 ? forecasts.map((item: any) => ({ x: item?.date, y: item?.quantity })) : []
      const localSalesData = history?.length > 0 ? history.map((item: any) => ({ x: item?.date, y: item?.quantity })) : []
      // const localSafetyStock = safety_stock.map((item: any) => ({ x: item.date, y: item.quantity }))
      const { randomDarkColor, randomLightColor } = getRandomColor(colorIndex)


      salesForecastArray.push({ name: `${state_name}(SF)`, color: randomDarkColor, data: localInventoryData, })
      SalesHistoryArray.push({ name: `${state_name}(SH)`, color: randomLightColor, data: localSalesData, })

      //  SafetyStock.push({ name: `${category} (SS)`, color: randomDarkColor, data: localSafetyStock, strokeDashArray: 10.5  })

      // obj.product_id ? productNames.push(`${category} - ${product_name} (${product_id})`) : productNames = []
      stateNames.push(state_name)

      // localCategoriesName.push(category)

      if (colorIndex < 4) {
        colorIndex = colorIndex + 1

      }
      else {
        colorIndex = 0
      }
    })

    const maxLengthObjectSales = SalesHistoryArray.reduce((max: any, current: any) => current?.data?.length > max?.data?.length ? current : max, SalesHistoryArray[0]);

    const maxLengthObjectSalesForecast = salesForecastArray.reduce((max: any, current: any) => current?.data?.length > max?.data?.length ? current : max, salesForecastArray[0])

    setDate(prev => ({
      ...prev, futureDate: maxLengthObjectSalesForecast?.data?.[maxLengthObjectSalesForecast?.data?.length - 1]?.x,
      lengthOfInventory: maxLengthObjectSalesForecast?.data?.length, pastDate: maxLengthObjectSales?.data?.[0]?.x
    }))

    setLegendNames(stateNames)
    setSalesForecastSeries(salesForecastArray)
    setSalesHistorySeries(SalesHistoryArray)
    // setSafetyStockData(SafetyStock)



  }

  const makeCityPlot = async () => {
    let salesForecastArray: any[] = [];
    let salesHistoryArray: any[] = [];
    let cityNames: string[] = [];
    let colorIndex = 0;

    graphData?.result.forEach((stateObj: any) => {
      // Loop through each city in city_data
      stateObj?.city_data?.forEach((cityObj: any) => {
        const { forecasts, history, city_name } = cityObj;

        // Generate data points for forecasts and history if available
        const localInventoryData = forecasts.map((item: any) => ({ x: item?.date, y: item?.quantity }));
        const localSalesData = history.map((item: any) => ({ x: item?.date, y: item?.quantity }));

        // Get color for forecast and history
        const { randomDarkColor, randomLightColor } = getRandomColor(colorIndex);

        // Push formatted data into respective arrays
        salesForecastArray.push({
          name: `${city_name} (SF)`,
          color: randomDarkColor,
          data: localInventoryData,
        });

        salesHistoryArray.push({
          name: `${city_name} (SH)`,
          color: randomLightColor,
          data: localSalesData,
        });

        cityNames.push(city_name);

        // Cycle color index
        colorIndex = (colorIndex + 1) % 5;  // Assuming 5 unique colors
      });
    });

    // Find the city with the longest data history for dates
    const maxLengthObjectSales = salesHistoryArray.reduce(
      (max, current) => current?.data?.length > max.data.length ? current : max,
      salesHistoryArray[0]
    );

    const maxLengthObjectSalesForecast = salesForecastArray.reduce(
      (max, current) => current?.data?.length > max.data.length ? current : max,
      salesForecastArray[0]
    );

    // Set dates for the longest data arrays
    setDate(prev => ({
      ...prev,
      futureDate: maxLengthObjectSalesForecast?.data?.[maxLengthObjectSalesForecast.data.length - 1]?.x,
      lengthOfInventory: maxLengthObjectSalesForecast?.data?.length,
      pastDate: maxLengthObjectSales?.data?.[0]?.x,
    }));

    // Update state with arrays and legends
    setLegendNames(cityNames);
    setSalesForecastSeries(salesForecastArray);
    setSalesHistorySeries(salesHistoryArray);

  };


  const makeManagerPlot = async () => {

    let salesForecastArray: any = []
    let SalesHistoryArray: any = []

    let managerNames: string[] = []
    let colorIndex = 0

    graphData?.result.forEach((obj: graphManagerType) => {


      const { forecasts, history, sales_manager } = obj

      const localInventoryData = forecasts.length > 0 ? forecasts.map((item: any) => ({ x: item.date, y: item.quantity })) : []
      const localSalesData = history.length > 0 ? history.map((item: any) => ({ x: item.date, y: item.quantity })) : []
      // const localSafetyStock = safety_stock.map((item: any) => ({ x: item.date, y: item.quantity }))
      const { randomDarkColor, randomLightColor } = getRandomColor(colorIndex)


      salesForecastArray.push({ name: `${sales_manager}(SF)`, color: randomDarkColor, data: localInventoryData, })
      SalesHistoryArray.push({ name: `${sales_manager}(SH)`, color: randomLightColor, data: localSalesData, })

      //  SafetyStock.push({ name: `${category} (SS)`, color: randomDarkColor, data: localSafetyStock, strokeDashArray: 10.5  })

      // obj.product_id ? productNames.push(`${category} - ${product_name} (${product_id})`) : productNames = []
      managerNames.push(sales_manager)

      // localCategoriesName.push(category)

      if (colorIndex < 4) {
        colorIndex = colorIndex + 1

      }
      else {
        colorIndex = 0
      }
    })

    const maxLengthObjectSales = SalesHistoryArray.reduce((max: any, current: any) => current.data.length > max.data.length ? current : max, SalesHistoryArray[0]);

    const maxLengthObjectSalesForecast = salesForecastArray.reduce((max: any, current: any) => current.data.length > max.data.length ? current : max, salesForecastArray[0])

    setDate(prev => ({
      ...prev, futureDate: maxLengthObjectSalesForecast?.data?.[maxLengthObjectSalesForecast?.data?.length - 1]?.x,
      lengthOfInventory: maxLengthObjectSalesForecast?.data?.length, pastDate: maxLengthObjectSales?.data?.[0]?.x
    }))

    setLegendNames(managerNames)
    setSalesForecastSeries(salesForecastArray)
    setSalesHistorySeries(SalesHistoryArray)



  }

  const makeSalesRepPlot = async () => {

    let salesForecastArray: any = []
    let SalesHistoryArray: any = []

    let salesRepNames: string[] = []
    let colorIndex = 0


    graphData?.result.forEach((obj: graphSalesRepType) => {


      const { forecasts, history, sales_associate } = obj

      const localInventoryData = forecasts.length > 0 ? forecasts.map((item: any) => ({ x: item.date, y: item.quantity })) : []
      const localSalesData = history.length > 0 ? history.map((item: any) => ({ x: item.date, y: item.quantity })) : []
      // const localSafetyStock = safety_stock.map((item: any) => ({ x: item.date, y: item.quantity }))
      const { randomDarkColor, randomLightColor } = getRandomColor(colorIndex)


      salesForecastArray.push({ name: `${sales_associate}(SF)`, color: randomDarkColor, data: localInventoryData, })
      SalesHistoryArray.push({ name: `${sales_associate}(SH)`, color: randomLightColor, data: localSalesData, })

      //  SafetyStock.push({ name: `${category} (SS)`, color: randomDarkColor, data: localSafetyStock, strokeDashArray: 10.5  })

      // obj.product_id ? productNames.push(`${category} - ${product_name} (${product_id})`) : productNames = []
      salesRepNames.push(sales_associate)

      // localCategoriesName.push(category)

      if (colorIndex < 4) {
        colorIndex = colorIndex + 1

      }
      else {
        colorIndex = 0
      }
    })

    const maxLengthObjectSales = SalesHistoryArray.reduce((max: any, current: any) => current.data.length > max.data.length ? current : max, SalesHistoryArray[0]);

    const maxLengthObjectSalesForecast = salesForecastArray.reduce((max: any, current: any) => current.data.length > max.data.length ? current : max, salesForecastArray[0])

    setDate(prev => ({
      ...prev, futureDate: maxLengthObjectSalesForecast?.data?.[maxLengthObjectSalesForecast?.data?.length - 1]?.x,
      lengthOfInventory: maxLengthObjectSalesForecast?.data?.length, pastDate: maxLengthObjectSales?.data?.[0]?.x
    }))

    setLegendNames(salesRepNames)
    setSalesForecastSeries(salesForecastArray)
    setSalesHistorySeries(SalesHistoryArray)



  }




  const currentDate = new Date().toISOString().slice(0, 10)
  const pastDateValue = date.pastDate
  const forecastDateValue = salesForecastSeries ? (date.lengthOfInventory && date.lengthOfInventory > 1 ? date.futureDate : currentDate) : currentDate


  //graph code starts here


  const tooltipFunction = ({ series, seriesIndex, dataPointIndex, w }: any) => {



    const seriesName = w.globals.seriesNames[seriesIndex];
    let valueLabel
    let date
    if (seriesName.includes('SH')) {
      valueLabel = 'Sales History Amount';
      if (filterMode === "country") {
        date = new Date(w.globals?.seriesX[0][dataPointIndex])
      }
      else if (filterMode === "state") {
        date = new Date(w.globals?.seriesX[0][dataPointIndex])
      }
      else if (filterMode === "city") {
        date = new Date(w.globals?.seriesX[0][dataPointIndex])
      }
      else if (filterMode === "manager") {
        date = new Date(w.globals?.seriesX[0][dataPointIndex])
      }
      else if (filterMode === "sales-rep") {
        date = new Date(w.globals?.seriesX[0][dataPointIndex])
      }else{
        date = new Date(w.globals?.seriesX[0][dataPointIndex])
      }
  


    } else if (seriesName.includes('SF')) {
      valueLabel = 'Sales Forecast Amount';


      if (filterMode === "country") {
        date = new Date(w.globals?.seriesX[1][dataPointIndex])
      }
      else if (filterMode === "state") {
        date = new Date(w.globals?.seriesX[12][dataPointIndex])
      }
      else if (filterMode === "city") {
        date = new Date(w.globals?.seriesX[3][dataPointIndex])
      }
      else if (filterMode === "manager") {
        date = new Date(w.globals?.seriesX[1][dataPointIndex])
      }
      else if (filterMode === "sales-rep") {
        date = new Date(w.globals?.seriesX[2][dataPointIndex])
      }
      else{
        date = new Date(w.globals?.seriesX[1][dataPointIndex])
      }
    
    }

    const yValue = series[seriesIndex][dataPointIndex];

    const xValue = tooltipFormat(date)

    return (
      `<div class="custom-chart-tooltip">
          <div class="tooltip-header"><b>${seriesName.split("(")[0]}</b> ${xValue}</div>
          <div class="tooltip-body">
            <p><b>${valueLabel} : </b> $${yValue.toLocaleString('en-US')}</p>
        </div>`
    );
  }


  const chartConfiguration: any = {
    options: {
      chart: {
        id: "forecast-area",
        offsetY: 50,
        toolbar: {

          tools: {
            download: false,
          }

        },
        animations: {
          enabled: true,
          easing: 'easeinout',
          speed: 800
        }
      },
      annotations: {
        xaxis: [//today
          {
            x: new Date(currentDate).getTime(),
            borderColor: "#FEB019",
            label: {
              borderColor: "#fff",
              style: {
                color: "#FEB019",
                background: "#fff",
                fontSize: "14px",
                fontWeight: 600,
              },
              offsetY: -23.5,
              text: "TODAY",
              orientation: "horizontal",
            },
            strokeDashArray: 10.5, // Adjust dash size
          },

          {//past
            x: new Date(pastDateValue).getTime(),
            borderColor: "#fff",
            label: {
              borderColor: "#fff",
              style: {
                color: "#00A9A1",
                background: "#fff",
                fontSize: "14px",
                fontWeight: 600,
              },
              offsetY: -20,
              offsetX: 55,
              text: "SALES HISTORY",
              orientation: "horizontal",
            },
            strokeDashArray: 0, // Adjust dash size
          },

          forecastDateValue !== currentDate &&
          {//forecast
            x: new Date(forecastDateValue).getTime(),
            borderColor: "#fff",
            label: {
              borderColor: "#fff",
              style: {
                color: "#3375A5",
                background: "#fff",
                fontSize: "14px",
                fontWeight: 600,
              },
              offsetY: -20,
              offsetX: -40,
              text: "FORECAST",
              orientation: "horizontal",
            },
            strokeDashArray: 0, // Adjust dash size
          },


        ],
      },
      stroke: {
        curve: "straight",
        width: 1,
      },

      fill: {
        // Primary colors
        type: "gradient",
      },
      dataLabels: {
        enabled: false,
      },

      markers: {
        size: 4,
        shape: "circle",
        hover: {
          size: 6,             // Keep size the same as normal
        
        }
      },
      tooltip: {
        enabled: true,
        followCursor: false,
        intersect: true,
        shared: false,
        custom: tooltipFunction,

        // intersect: true,
        //   x: {
        //     show: false,
        //     format: 'dd MMM',
        //     formatter: undefined,
        // },
        //   y: {
        //     formatter: tooltipFunction,
        //     title: {
        //         formatter: tooltipFunction,
        //     },
        // },
      },
      legend: {
        fontSize: "10.5px",
        show: true,
        customLegendItems: LegendNames,
        labels: {
          useSeriesColors: true
        },
        position: "bottom",
        // offsetY: legendItems.length >2 ? 12: -30,
        offsetY: 10,
        height: 150,
        // horizontalAlign: legendItems.length >5 ? (graphData.result[0].unique_products ? "center" : 'left') : 'center', 
        itemMargin: {
          horizontal: 4, // Horizontal margin between items
          vertical: 10 // Vertical margin between items
        }
      },
      grid: {
        padding: {
          right: 40,
          left: 15
        },
      },
      xaxis: {
        type: "datetime",
        labels: {
          datetimeUTC: false,
        },
        tooltip: {
          enabled: false // Ensure that the x-axis tooltip is disabled
        }
      },
      yaxis: {

        // tickAmount: 4 ,
        steps: 1,
        labels: {
          formatter: function formatter(value: number): string {

            const checkValue = value.toString().endsWith('000');

            const newValue = checkValue
              ? Number(value.toString().slice(0, -3)).toLocaleString('en-US') + 'K'  // Removes the last 3 digits, converts back to number, and formats it
              : (value % 1 === 0
                ? value.toLocaleString('en-US')
                : '');

            return newValue;
            // Hide decimal numbers

            // return value % 1 === 0 ? value.toLocaleString('en-US') : '';


          },
          style: {
            colors: ['grey'],
            fontSize: "12px",
            fontWeight: 600,
          },
        },
      }
    },  //series is written this way so that legend color is customized
    series: [...salesHistorySeries, ...salesForecastSeries,]
    ,
  }





  useEffect(() => {
    if (downloadCsv && currentUIView.chartView) {

      generatePDF()
      setDownloadCsv(false)
      // getValue()

    }

  }, [downloadCsv])


  async function generatePDF() {

    const filename = `${getFileName()}.pdf`;
    // const salesFilterData = pdfDownloadData.current.salesFilterData
    if (chartRef.current && cardRef.current && mapRef.current) {

      try {

        const pdf = new jsPDF('p', 'mm', 'a4'); // Portrait, millimeters, A4 size
        const pageWidth = 210; // A4 width in mm
        const pageHeight = 297; // A4 height in mm

        const imgWidth = 104;
        const imgHeight = 26;

        // Calculate the aspect ratio of the image
        const aspectRatioHeader = imgWidth / imgHeight;

        // Set the desired width for the PDF (adjust for a good fit, e.g., 70mm width)
        const headerWidth = 30;
        const headerHeight = headerWidth / aspectRatioHeader; // Maintain the aspect ratio


        // Add the image without resizing
        pdf.addImage(headerImage, 'PNG', (pageWidth - headerWidth) / 2, 10, headerWidth, headerHeight);


        // Main Content
        pdf.setFontSize(18);
        pdf.text('Sales Forecast', pageWidth / 2, 30, { align: 'center' }); // Centered horizontally


        const columns: TableColumn[] = [
          { title: 'Forecast By', dataKey: 'col1' },
          { title: 'Start Date', dataKey: 'col2' },
          { title: 'End Date', dataKey: 'col3' }
        ];

        const data: TableRow[] = [
          { col1: salesFilterData.forecast_by, col2: salesFilterData.forecast_range_start_date, col3: salesFilterData.forecast_range_end_date },
        ];

        // Use jsPDF.autoTable
        autoTable(pdf, {
          startY: 43, // Adjust based on where you want the table to start
          head: [columns.map(col => col.title)],
          body: data.map(row => columns.map(col => row[col.dataKey] ?? "")),
          theme: 'striped', // You can customize the table appearance
          margin: { top: 10 }

        });
        //font style
        pdf.setFontSize(11);
        pdf.setFont("helvetica", "normal");
        //card section starts here

        const highlightsRef = cardRef.current; // Assuming you have a ref for the highlights section
        let cardImgURI = '';

        if (highlightsRef) {
          const canvas = await html2canvas(highlightsRef);
          cardImgURI = canvas.toDataURL('image/png'); // Convert canvas to image data URI
        }



        pdf.text("Highlights for sales forecast", 15, 70);

        const sectionWidth = 190;
        const sectionHeight = 30;



        // Add the captured image to the PDF with custom dimensions
        pdf.addImage(cardImgURI, 'PNG', 10, 80, sectionWidth, sectionHeight);



        // const mapWidth = 1870
        // const mapHeight = 640
        // const newMapWidth = pageWidth - 20; // 10mm margin on each side


        // const aspectRatioMap = mapWidth / mapHeight;

        // let newMapHeight = (newMapWidth / aspectRatioMap);
        // const maxMapHeight = pageHeight - 90; // Leaving space for margins
        // if (newMapHeight > maxMapHeight) {

        //   newMapHeight = newMapHeight;
        // }
        // const scale = window.devicePixelRatio || 1;

        // const mapElement = mapRef.current.getContainer();
        // const mapImgURI = await html2canvas(mapElement, { useCORS: true, allowTaint: true, scale: scale, })
        //   .then(canvas => canvas.toDataURL('image/png'))
        //   .catch(error => {
        //     console.error('Error capturing map:', error);
        //     return ''; // Return an empty string in case of an error
        //   });

        // pdf.text("Forecast by geography", 15, 123);
        // if (mapImgURI) {
        //   pdf.addImage(mapImgURI, 'PNG', 10, 133, newMapWidth, newMapHeight);
        // }



        //graph section starts here
        const { imgURI: chartImgURI } = await chartRef.current.chart.dataURI();
        pdf.text("Graph View for sales forecast", 15, 123); //209

        // Adjust graph image size and position
        const chartWidth = 1476;
        const chartHeight = 430;

        const graphWidth = pageWidth - 20; // 10mm margin on each side


        const aspectRatio = chartWidth / chartHeight;

        let graphHeight = (graphWidth / aspectRatio);

        const maxHeight = pageHeight - 90; // Leaving space for margins
        if (graphHeight > maxHeight) {

          graphHeight = maxHeight;
        }

        pdf.addImage(chartImgURI, 'PNG', 10, 133, graphWidth, graphHeight); //  210

        // Adjust footer size and position
        const footerWidth = 30; // Smaller width for footer
        const footerHeight = (20 * footerWidth) / 142; // Scale height proportionally
        pdf.addImage(footerImage, 'PNG', (pageWidth - footerWidth) / 2, pageHeight - footerHeight - 10, footerWidth, footerHeight); // Centered horizontally and 10mm margin from the bottom

        // Save the PDF with a defined filename
        pdf.save(filename);

      } catch (error) {
        console.error('Failed to download chart:', error);
      }

    }

  }



  return (
    <section className="forecast-timeline">
      <h5>Forecast by Timeline</h5>
      {(salesForecastSeries.length > 0 || salesHistorySeries.length > 0) ? (
        <Chart options={chartConfiguration.options} series={chartConfiguration.series} height={430} type="area" ref={chartRef} />

      ) : (
        <div className="custom-empty-message">No data available for this selection</div>
      )}
    </section>
  )
})


export default Graph



